// Açılış ekranı `public/index.html` içinde durur ve sitenin kendi logosunu
// gösterir; React'in yüklenmesini beklemeden görünür olması gerektiği için
// paketin dışındadır. Kaldırma işi buradadır: ayarlar gelip tema, marka ve
// vitrin hazır olduğunda ekran söner, oyuncu doğrudan kendi sitesini görür.
export const SPLASH_ELEMENT_ID = 'app-splash';
// CSS'teki geçiş süresiyle aynı kalmalı (#app-splash transition: 280ms).
const FADE_MS = 320;

// Site hazır olur olmaz ekran söner; hiçbir şemada ek bekleme yoktur.
// Betrun'da bir süre site hazır olduktan sonra 1,5 sn bekleme ve logonun
// çizilmesini (en çok 3 sn) bekleyen bir tutma vardı; kurulum açılışın
// gecikmesini istemediği için ikisi de kaldırıldı (02.10.2026).
let hidden = false;

export const hideSplash = ({
  doc = typeof document !== 'undefined' ? document : null,
} = {}) => {
  if (hidden || !doc) return false;
  const splash = doc.getElementById(SPLASH_ELEMENT_ID);
  if (!splash) return false;
  hidden = true;
  splash.classList.add('is-hidden');
  // Geçiş bitince DOM'dan düşer; kalırsa tıklamaları yutmasa da ekran
  // okuyucuya "yükleniyor" demeye devam ederdi.
  setTimeout(() => splash.remove(), FADE_MS);
  return true;
};

// Açılış ekranı `public/index.html` içinde son bilinen markayla (localStorage)
// ya da önden istenen ayarlarla doldurulur. İkisi de boş kaldıysa — depolama
// kapalı, ön istek başarısız — ayarlar uygulamaya geldiğinde burada doldurulur:
// panelden yazılan özel kod logoyu `#app-splash-logo`'dan okur. Zaten dolu ekrana
// dokunulmaz: çizilmiş bir logoyu değiştirmek ekranı titretirdi. `brand`,
// lib/brand.js `cacheBrand` çıktısıdır (logo adresi çözülmüş).
export const SPLASH_LOGO_ID = 'app-splash-logo';
export const SPLASH_TEXT_ID = 'app-splash-text';

const LOGO_PATTERN = /^(?:https?:\/\/|\/)[^\s"'<>]{1,300}$/;

const drawText = (doc, text, brand) => {
  const primary = brand.logo_text_primary || brand.site_name || '';
  if (!text || !primary) return false;
  const accent = doc.createElement('span');
  accent.className = 'app-splash-accent';
  accent.textContent = primary;
  text.appendChild(accent);
  const secondary = brand.logo_text_primary ? brand.logo_text_secondary || '' : '';
  if (secondary) text.appendChild(doc.createTextNode(secondary));
  return true;
};

export const fillSplash = (
  brand = {},
  { doc = typeof document !== 'undefined' ? document : null } = {},
) => {
  if (hidden || !doc || !brand) return false;
  if (!doc.getElementById(SPLASH_ELEMENT_ID)) return false;
  const image = doc.getElementById(SPLASH_LOGO_ID);
  const text = doc.getElementById(SPLASH_TEXT_ID);
  if ((image && !image.hidden) || text?.firstChild) return false;
  const logo = String(brand.logo_image_url || '').trim();
  if (image && LOGO_PATTERN.test(logo)) {
    image.onerror = () => {
      image.hidden = true;
      image.removeAttribute('src');
      drawText(doc, text, brand);
    };
    image.src = logo;
    image.hidden = false;
    return true;
  }
  return drawText(doc, text, brand);
};

// Testler için: modül durumu sıfırlanır.
export const resetSplashState = () => { hidden = false; };

export default hideSplash;
